export default {
  'menu.welcome': 'Welcome',
  'menu.home': 'Home',
  'menu.login': 'Login',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': 'Analysis',
  'menu.dashboard.monitor': 'Monitor',
  'menu.dashboard.workplace': 'Workplace',

  'menu.catalog': 'Catalog',
  'menu.catalog.products': 'Products',
  'menu.catalog.categories': 'Categories',
  'menu.catalog.inventory': 'Inventory',
  'menu.catalog.media': 'Media',

  'menu.orders': 'Orders',
  'menu.orders.orders': 'Orders',
  'menu.orders.inquiries': 'Inquiries',
  'menu.orders.quotations': 'Quotations',
  'menu.orders.abandoned': 'Abandoned Carts',

  'menu.customers': 'Customers',
  'menu.customers.list': 'Customers',
  'menu.customers.groups': 'Customer Groups',

  'menu.content': 'Content',
  'menu.content.pages': 'Pages',
  'menu.content.blog': 'Blog / News',
  'menu.content.navigation': 'Navigation',
  'menu.content.banners': 'Banners',

  'menu.marketing': 'Marketing',
  'menu.marketing.discounts': 'Discounts',
  'menu.marketing.email': 'Email Marketing',
  'menu.marketing.seo': 'SEO Settings',
  'menu.marketing.analytics': 'Analytics',

  'menu.settings': 'Settings',
  'menu.settings.store': 'Store Settings',
  'menu.settings.domains': 'Domains',
  'menu.settings.languages': 'Languages',
  'menu.settings.currencies': 'Currencies',
  'menu.settings.shipping': 'Shipping',
  'menu.settings.taxes': 'Taxes',
  'menu.settings.payments': 'Payments',
  'menu.settings.notifications': 'Notifications',

  'menu.system': 'System',
  'menu.system.users': 'Users & Roles',
  'menu.system.audit': 'Audit Logs',
  'menu.system.integrations': 'Integrations',

  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.account': 'Account',
  'menu.account.center': 'Account Center',
  'menu.account.settings': 'Account Settings',
  'menu.account.logout': 'Logout',
};
